import InitApi from "api/InitApi";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";
import toast from "react-hot-toast";
import { deleteEmptyObjects } from "utils";
import ServerErrors from "components/SeverErrors";

const useAddPhysicalBook = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();

	const addBook = async (obj) => {
		const instance = await InitApi({ accessToken }, "multipart/form-data");

		const body = deleteEmptyObjects(obj);

		const formData = new FormData();
		Object.keys(body).forEach((key) => {
			formData.append(key, body[key]);
		});

		const response = await instance.post("/books/physical", formData);
		await queryClient.invalidateQueries("books");
		await queryClient.invalidateQueries("myUploadedBooks");
		return response?.data;
	};

	return useMutation(addBook, {
		onSuccess: async ({ data: body }) => {
			toast.success("Book added successfully");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useAddPhysicalBook;
